import type { FunctionComponent, ReactNode } from "react";
import { graphql, useFragment } from "react-relay";

import { ArticlePaywallChecker } from "~/components/article/article-paywall-checker";
import { ContentReadMoreChecker } from "~/components/content/content-read-more/content-read-more-checker";
import type { globalCheckerContent$key } from "~/queries/__generated__/globalCheckerContent.graphql";

type Props = {
  children?: ReactNode;
  reference: globalCheckerContent$key;
};

export const GlobalChecker: FunctionComponent<Props> = ({ children, reference }) => {
  const content = useFragment(
    graphql`
      fragment globalCheckerContent on Content {
        ...articlePaywallCheckerContent
      }
    `,
    reference,
  );

  return (
    <ArticlePaywallChecker reference={content}>
      <ContentReadMoreChecker>{children}</ContentReadMoreChecker>
    </ArticlePaywallChecker>
  );
};

GlobalChecker.displayName = "GlobalChecker";
